var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_main_contents" }, [
    _c("div", { staticClass: "setting_heading" }, [
      _c("h1", { staticClass: "setting_heading_title" }, [
        _vm._v("\n      " + _vm._s(_vm.labelMasterProperties.HEADER) + "\n    ")
      ]),
      _c("p", { staticClass: "setting_heading_explain" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.labelMasterProperties.HEADER_EXPLAIN) +
            "\n    "
        )
      ]),
      _c(
        "button",
        {
          staticClass: "setting_btn_outline btn-secondary-color mb-3",
          on: {
            click: function($event) {
              return _vm.resetMasterData()
            }
          }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.labelMasterProperties.BUTTON_RESET_MASTER_DATA) +
              "\n    "
          )
        ]
      )
    ]),
    _c(
      "div",
      { class: { overlay_setting: _vm.isLoadingData || _vm.isResetData } },
      [
        _c("i", {
          class: { loadding_setting: _vm.isLoadingData || _vm.isResetData }
        })
      ]
    ),
    _c("div", { staticClass: "setting_tab_content" }, [
      _c("div", { staticClass: "setting_tab_content_panel is_active" }, [
        _c("div", { staticClass: "setting_content" }, [
          _c("div", { staticClass: "setting_content_main" }, [
            _c("div", { staticClass: "setting_category_header" }, [
              _c("div", { staticClass: "setting_category_header_content" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.labelMasterProperties.CATEGORY_HEADER) +
                    "\n            "
                )
              ]),
              _c(
                "div",
                { staticClass: "setting_category_header_operation_small" },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.labelMasterProperties.HEADER_OPERATION) +
                      "\n            "
                  )
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "setting_category_wrapper" },
              _vm._l(_vm.masterSettings, function(masterSetting, index) {
                return _c("div", { key: index }, [
                  _c(
                    "div",
                    {
                      staticClass: "setting_column_item",
                      class: {
                        master_item_deleted:
                          masterSetting && masterSetting.deletedDate
                      },
                      attrs: {
                        title:
                          masterSetting && masterSetting.deletedDate
                            ? _vm.messageMasterProperties.MASTER_DELETED
                            : ""
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "setting_column_item_content setting_master_item_holder_name"
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(masterSetting.name) +
                              "\n                "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "setting_column_item_operation_add" },
                        [
                          _c(
                            "div",
                            { staticClass: "setting_column_item_operation" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "setting_btn_secondary setting_btn_medium",
                                  class: {
                                    setting_btn_disabled:
                                      masterSetting && masterSetting.deletedDate
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.openEditMaster(index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.labelMasterProperties
                                          .BUTTON_EDIT_MASTER
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      masterSetting && masterSetting.deletedDate
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "setting_btn_delete setting_btn_medium",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openDeleteModal(index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.labelMasterProperties
                                      .BUTTON_DELETE_MASTER
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "setting_footer" }, [
      _c(
        "button",
        {
          staticClass: "setting_btn_outline",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.cancelChange($event)
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.labelProperties.CANCEL_BUTTON) + "\n    "
          )
        ]
      ),
      _c(
        "button",
        {
          staticClass: "setting_btn_primary",
          class: { setting_btn_disabled: !_vm.canSaveMaster },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.saveMasters($event)
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.labelProperties.SAVE_BUTTON) + "\n    "
          )
        ]
      ),
      _vm.unSavedData
        ? _c("div", { staticClass: "setting_footer_balloon" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.labelMasterProperties.SAVE_CHANGE_DATA) +
                "\n    "
            )
          ])
        : _vm._e()
    ]),
    _vm.isOpenEditModal
      ? _c("div", { staticClass: "setting_modal" }, [
          _c("div", { staticClass: "setting_master_modal" }, [
            _c("div", { staticClass: "setting_master_modal_header" }, [
              _c(
                "p",
                {
                  staticClass:
                    "setting_master_modal_header_title setting_master_item_holder_name"
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.selectedMaster.name +
                          _vm.labelMasterProperties.MODAL_HEADER_TITLE
                      ) +
                      "\n        "
                  )
                ]
              ),
              _c("div", { staticClass: "setting_master_modal_header_close" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "12",
                      height: "12",
                      xmlns: "http://www.w3.org/2000/svg"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.closeEditMasterModal($event)
                      }
                    }
                  },
                  [
                    _c(
                      "g",
                      { attrs: { fill: "#AAA", "fill-rule": "evenodd" } },
                      [
                        _c("path", {
                          attrs: { d: "M.255 1.545l.99-.99 9.9 9.9-.99.99z" }
                        }),
                        _c("path", {
                          attrs: { d: "M10.155.555l.99.99-9.9 9.9-.99-.99z" }
                        })
                      ]
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "setting_master_modal_body" }, [
              _c("div", { staticClass: "setting_master_item_header" }, [
                _c(
                  "div",
                  { staticClass: "setting_master_item_header_sorting" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.labelMasterProperties.ITEM_HEADER_SORTING) +
                        "\n          "
                    )
                  ]
                ),
                _c("div", { staticClass: "setting_master_item_header_name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.labelMasterProperties.ITEM_HEADER_NAME) +
                      "\n          "
                  )
                ]),
                _c("div", { staticClass: "setting_master_item_header_form" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.labelMasterProperties.ITEM_HEADER_FORM) +
                      "\n          "
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "setting_master_item_header_display" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.labelMasterProperties.ITEM_HEADER_DISPLAY) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "setting_master_item_wrapper" },
                [
                  _c(
                    "draggable",
                    {
                      attrs: {
                        list: _vm.selectedMaster.items,
                        handle: ".handle"
                      }
                    },
                    [
                      _vm._l(_vm.selectedMaster.items, function(item, index) {
                        return [
                          _c(
                            "div",
                            {
                              key: index,
                              staticClass: "setting_master_item_holder",
                              class: {
                                master_item_deleted: item && item.deletedDate
                              },
                              attrs: {
                                title:
                                  item && item.deletedDate
                                    ? _vm.messageMasterProperties.ITEM_DELETED
                                    : ""
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "setting_master_item_holder_sorting handle"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "setting_master_item_holder_sorting_icon",
                                      attrs: {
                                        width: "10",
                                        height: "12",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            fill: "#aaa",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "setting_master_item_holder_name"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.choiceName) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "setting_master_item_holder_form"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: item.choiceDisplayName,
                                        expression: "item.choiceDisplayName"
                                      }
                                    ],
                                    staticClass: "setting_form_text",
                                    attrs: { type: "text", placeholder: "" },
                                    domProps: { value: item.choiceDisplayName },
                                    on: {
                                      change: function($event) {
                                        return _vm.validateChoiceDisplayName(
                                          index
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          item,
                                          "choiceDisplayName",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.choiceDisplayErrors.includes(
                                            index
                                          ),
                                          expression:
                                            "choiceDisplayErrors.includes(index)"
                                        }
                                      ],
                                      staticClass: "error_msg"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.configMasterProperties
                                              .CHOICE_DISPLAY_NAME_MAX_LENGTH +
                                              _vm.messageMasterProperties
                                                .CHOICE_DISPLAY_NAME_MAX_LENGTH
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "setting_master_item_holder_display"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "setting_form_checkbox_label"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: item.show,
                                            expression: "item.show"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          checked: ""
                                        },
                                        domProps: {
                                          checked: Array.isArray(item.show)
                                            ? _vm._i(item.show, null) > -1
                                            : item.show
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = item.show,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    item,
                                                    "show",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    item,
                                                    "show",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(item, "show", $$c)
                                            }
                                          }
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "setting_form_checkbox_text"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.labelMasterProperties
                                                  .FORM_CHECKBOX_TEXT
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "setting_master_modal_footer" }, [
              _c(
                "button",
                {
                  staticClass: "setting_btn_outline",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.closeEditMasterModal($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.labelMasterProperties.BUTTON_CLOSE) +
                      "\n        "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "setting_btn_primary",
                  class: { setting_btn_disabled: !_vm.canReflectMaster },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.submitMasterItems($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.labelMasterProperties.BUTTON_OK) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm.isOpenDeleteModal
      ? _c("div", { staticClass: "setting_modal" }, [
          _c("div", { staticClass: "setting_modal_box" }, [
            _c("div", { staticClass: "setting_modal_box_body" }, [
              _c(
                "div",
                {
                  staticClass: "setting_modal_box_close",
                  on: { click: _vm.closePopupDeleteMaster }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c(
                        "g",
                        { attrs: { fill: "#AAA", "fill-rule": "evenodd" } },
                        [
                          _c("path", {
                            attrs: { d: "M.255 1.545l.99-.99 9.9 9.9-.99.99z" }
                          }),
                          _c("path", {
                            attrs: { d: "M10.155.555l.99.99-9.9 9.9-.99-.99z" }
                          })
                        ]
                      )
                    ]
                  )
                ]
              ),
              _c("p", { staticClass: "setting_modal_box_text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.messageMasterProperties.CONFIRM_DELETE_MASTER_MESSAGE
                    ) +
                    "\n        "
                )
              ])
            ]),
            _c("div", { staticClass: "setting_modal_box_actions" }, [
              _c(
                "button",
                {
                  staticClass: "setting_btn_outline",
                  on: { click: _vm.closePopupDeleteMaster }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.labelMasterProperties.BUTTON_CLOSE) +
                      "\n        "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "setting_btn_primary",
                  on: {
                    click: function($event) {
                      return _vm.deleteMaster()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.labelMasterProperties.BUTTON_OK) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }